<mat-toolbar class="header-content">
    <div class="header-title">
        <mat-icon>edit</mat-icon>
        {{ 'trackers.configure_selection' | translate }} ({{ trackers.length }})
    </div>

    <lib-button icon="close" color="none" textColor="muted" (click)="cancel()"
        tooltip="{{'viewer.close'|translate}}"></lib-button>
</mat-toolbar>

<mat-dialog-content>
    <p class="bulk-warning">{{ 'trackers.bulk_config_warning' | translate }}</p>

    <!-- The form below edits the shared values about to be applied to every selected tracker
         (see save()). Picking a template prefills it and links it to every tracker. -->
    <div class="config-select-row">
        <mat-form-field appearance="outline" class="header-input">
            <mat-label>{{'resources.select_kyd_template'|translate}}</mat-label>

            <mat-select [value]="editor.appliedTemplateId" (selectionChange)="editor.applyTemplate($event.value)"
                name="kydTemplate">
                <mat-option *ngFor="let config of editor.templates" [value]="config.id">{{config.name}}</mat-option>
            </mat-select>
        </mat-form-field>
    </div>
    <div class="template-hint">{{'resources.select_kyd_template_hint'|translate}}</div>

    <app-tracker-config-form [config]="editor.draft" [lockType]="type" [hideName]="true" (save)="save()"
        (saveAsTemplate)="onSaveAsTemplate()" (cancelForm)="cancel()"></app-tracker-config-form>
</mat-dialog-content>
